import { CardInstance } from './card';

// プレイヤー種別
export type PlayerType = 'human' | 'bot';

// Bot難易度
export type BotDifficulty = 'easy' | 'normal' | 'hard';

// プレイヤー基本情報
export interface PlayerInfo {
  id: string;
  name: string;
  avatar?: string;
  type: PlayerType;
  botDifficulty?: BotDifficulty;
}

// プレイヤーのゲーム状態
export interface PlayerState {
  info: PlayerInfo;
  deck: CardInstance[];       // 現在のデッキ
  bench: CardInstance[];      // ベンチ (退場カード置き場)
  benchLimit: number;         // ベンチ上限 (デフォルト6, 拡張可能)
  fans: number;               // 獲得ファン数
  matchHistory: MatchRecord[];
  isEliminated: boolean;      // 敗退フラグ
  eliminatedRound?: number;   // 敗退ラウンド
}

// 対戦履歴
export interface MatchRecord {
  round: number;
  opponentId: string;
  result: 'win' | 'lose';
  fansGained: number;
}

// ロビー待機中のプレイヤー
export interface LobbyPlayer {
  info: PlayerInfo;
  isReady: boolean;
  joinedAt: number;
}

// デフォルト値
export const DEFAULT_BENCH_LIMIT = 6;
export const DEFAULT_STARTING_FANS = 0;
export const DEFAULT_STARTING_DECK_SIZE = 6;

// 敗退条件 (ファンが負の値になったら敗退)
export const ELIMINATION_THRESHOLD = 0;
